import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('reporting-enablement', {
  library: 'reporting-enablement'
});